interface DeclarationsFormDefaultValues {
  declarations_electronicInterface: boolean;
  declarations_notEstablished: boolean;
  declarations_country_of_business_id: number | null;
}

export function handleDeclarationsFormDefaultValues(
  declarations_electronicInterface: boolean,
  declarations_notEstablished: boolean,
  declarations_country_of_business_id: number | null
): DeclarationsFormDefaultValues {
  return {
    declarations_electronicInterface: declarations_electronicInterface,
    declarations_notEstablished: declarations_notEstablished,
    declarations_country_of_business_id: declarations_country_of_business_id,
  };
}
